var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.validSettings)?_c('span',[_vm._v(_vm._s(_vm.internalLatitude)+"; "+_vm._s(_vm.internalLongitude))]):_c('span',[_vm._v("Not set")])
}
var staticRenderFns = []

export { render, staticRenderFns }